// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3M95b","footer":"ModalInfo_footer__BTFkA"};